import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './NeighborhoodMap.module.scss';

export const NeighborhoodMap: FC = ({ children }) => {
	return (
		<div className={classNames(styles.neighborhoodMap, 'neighborhoodMap')}>
			<div className={styles.neighborhoodMapHolder}>{children}</div>
		</div>
	);
};
